import store from '../reducers'
import {
    PageActions, 
    WaitingRoomActions, 
    ConfigActions, 
    AppointmentActions, 
    TimeSlotActions, 
    SelectedTimeSlotActions,
    SelectedPatientActions,
    PatientActions,
    ShiftActions,
    OpenTimeActions
} from 'actions'
import events from 'actions/events'
import dayjs from 'lib/helpers/dayjs';

export default () => {
    ConfigActions.append({
        hideSteps: true,
        placeholderAppointment: true,
        showOperatingHours: true,
        hideBackButton: true
    })

    let waitingRoomRefresh = ''

    events.on('Filters.componentWillMount',()=>{
        ShiftActions.fetch({ 
            organizationID: store.getState().config.organizationID,
            startingAt: dayjs().startOf('week').format(),
            endingAt: dayjs().endOf('week').format(),
            active: true
        })
        OpenTimeActions.fetch()
        waitingRoomRefresh = WaitingRoomActions.fetch()
        setInterval(()=>{
            WaitingRoomActions.fetch()
        },30000)
    })

    events.on('Filters.componentDidSubmit',()=>{
        clearInterval(waitingRoomRefresh)

        let administratorID = ''
        for(let key of Object.keys(store.getState().administrators)){
            if(store.getState().administrators[key].isWaitingRoom){
                administratorID = key
            }
        }

        let appointmentType
        if(store.getState().filters.appointmentTypeID){
            appointmentType = store.getState().appointmentTypes[store.getState().filters.appointmentTypeID]
        }

        const startsAt = dayjs().format()
        const endsAt = dayjs().add(1, 'minutes').format()
        const selectedTimeslot = {
            id: `${administratorID}-${startsAt}-${endsAt}`,
            startsAt,
            endsAt,
            administratorID,
        }

        if(appointmentType){
            selectedTimeslot.appointmentTypeID = appointmentType.id

            console.log({
                selectedTimeslot,
                appointmentType
            });
            
            selectedTimeslot.endsAt = dayjs(selectedTimeslot.startsAt).add(appointmentType.durations.split(',')[0], "minutes").format()
        }

        TimeSlotActions.set({
            [`${administratorID}`]:{
                [`${selectedTimeslot.id}`]: selectedTimeslot
            }
        })
        SelectedTimeSlotActions.set(selectedTimeslot)

        let selectedPatientIDs = Object.keys(store.getState().selectedPatients)
        if(selectedPatientIDs.length != store.getState().filters.patientCount){
            let patients = {}
            for(let i = store.getState().filters.patientCount - selectedPatientIDs.length; i > 0; i--){
                patients[`newPatient-fill-${i}`] = {id: `newPatient-fill-${i}`, name: `Patient ${i}`}
            }
            PatientActions.set(patients)
            SelectedPatientActions.appendMany(patients)
        }

        PageActions.navToCollectInformation()
    })

    events.on("Account.accountDidSubmit",()=>{
        if((store.getState().session.account || {}).id){
            AppointmentActions.fetch()
        }
    })

    events.on('CollectInformation.componentDidSubmit',()=>{
        PageActions.navToConfirmation()
    })

    events.on('Confirmation.componentDidSubmit',()=>{
        WaitingRoomActions.fetch()
        waitingRoomRefresh = setInterval(()=>{
            WaitingRoomActions.fetch()
        },10000)
        PageActions.navToReceipt()
    })
}


// WEBPACK FOOTER //
// ./eventFlows/walkIn.js